import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { openOreEndInterface } from "./openOreConst";
import openOreOpen from "./openOreOpen";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class openOreEventPage extends cc.Component {

    @property({type:cc.Node,displayName:"center节点"})
    centerNode:cc.Node = null;

    @property({type:cc.Node,displayName:"按钮layout"})
    btnLayout:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Explain:cc.Label = null;

    @property({type:cc.Label,displayName:"价格文本"})
    lbPrice:cc.Label = null;

    openEndInterface:openOreEndInterface = null;

    openOreOpen:openOreOpen = null;

    bindData(openEndInterface:openOreEndInterface,openOreOpen:openOreOpen = null){
        this.openEndInterface = openEndInterface;
        if ( this.openEndInterface ) {
            let rate = NormalGameManager._instance.getPriceRate();
            this.openEndInterface.price = Math.floor( rate * this.openEndInterface.price );
        }
        this.openOreOpen = openOreOpen;
        this.lbPrice.string = data_control.getNumberFormat(openEndInterface.price);
    }

    onLoad(){
        this.eventShow();
    }

    eventShow(){
        this.centerNode.x = -1000;
        cc.tween(this.centerNode).to(1,{x:0},{easing:cc.easing.backOut}).start();
        this.scheduleOnce(this.showExplain,1.5);
    }

    async eventHide(){
        return new Promise<void>(resolve=>{
            cc.tween(this.centerNode).delay(0.5).to(1,{x:-1000},{easing:cc.easing.backIn}).start();
            this.scheduleOnce(resolve,1.5);
        });
    }

    async showExplain(){
        let explain = this.openEndInterface.describe;
        let s = "";
        for(let i =0;i<explain.length;i++){
            await new Promise<void>(resolve=>{
                s+= explain[i];
                this.lb_Explain.string = s;
                this.scheduleOnce(resolve,0.02);
            });
        }
    }

    canClick:boolean = true;

    async onBtnSell(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        let targetNode:cc.Node = e?.target;
        O1HD.getServices().userSrv.setCoins(this.openEndInterface?.price,true,targetNode);
        await this.eventHide();
        if(this.openOreOpen){
            this.openOreOpen.node.destroy();
            this.openOreOpen.node.removeFromParent();
        }
        this.closeThis();
    }

    async onBtnNext(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        await this.eventHide();
        this.openOreOpen.canCut = true;
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
